
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurant/[id]/[name]",
      function () {
        return require("private-next-pages/restaurant/[id]/[name].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restaurant/[id]/[name]"])
      });
    }
  